export default class s {
  constructor(t = !1, s = []) {
    (this.L = t), (this.ge = s), (this.L = t), (this.ge = s);
  }
  P(t) {
    (this.L = this.L && t.L), this.ge.push(...t.ge);
  }
}
